import { Text, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { TripType } from '@eti/schema-types';
import { getBoundTitle, getBoundType } from '../../../../../../widgets/trip-details/utils/format';

interface ItineraryBoundTitleProps {
  boundId: string;
  boundIndex: number;
  journeyType: TripType;
}
const BoundTitle = ({ boundId, boundIndex, journeyType }: ItineraryBoundTitleProps) => {
  const { t } = useTranslation();
  const isMultiStop = journeyType !== TripType.OneWay && journeyType !== TripType.Return;
  const boundTitle = t(
    getBoundTitle(getBoundType(boundIndex), isMultiStop),
    parseInt(boundId, 10) + 1,
  );

  return (
    <Text data-testid="itinerary-bound-title" variant={textVariants._18_EMPHASIZED}>
      {boundTitle}
    </Text>
  );
};

export default BoundTitle;
